import React from 'react';
import { Gamepad2, Database, Layout, Sparkles } from 'lucide-react';
import { SERVICES } from '../data';

const Icons: Record<string, React.ElementType> = {
  Gamepad2,
  Database,
  Layout,
  Sparkles,
};

export const Services: React.FC = () => {
  return (
    <section id="services" className="py-20 bg-slate-900/50 border-y border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Technical Capabilities</h2>
          <p className="text-slate-400 max-w-2xl mx-auto">
            Every plugin is built to be fully configurable and optimized for high player counts.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {SERVICES.map((service) => {
            const Icon = Icons[service.iconName] || Gamepad2;

            return (
              <div key={service.id} className="group p-6 bg-slate-950 border border-slate-800 rounded-xl hover:border-mc-blue/50 transition-all hover:-translate-y-1">
                <div className="w-12 h-12 rounded-lg bg-slate-900 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform border border-slate-800 group-hover:border-mc-blue/20">
                  <Icon className={`w-6 h-6 ${service.iconColorClass}`} />
                </div>
                <h3 className="text-xl font-bold text-white mb-3 font-mono">{service.title}</h3>
                <p className="text-slate-400 text-sm leading-relaxed">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};